import React from 'react';
import { CopyableBlock } from './CopyableBlock';

const renderQuoteCards = (cards) => {
  if (!Array.isArray(cards) || cards.length === 0) return '';
  return cards
    .map((c, i) => {
      if (typeof c === 'string') return `Card ${i + 1}: ${c}`;
      const quote = c.quote || '';
      const author = c.author ? ` — ${c.author}` : '';
      const visual = c.visual ? `\n  Visual: ${c.visual}` : '';
      return `Card ${i + 1}: “${quote}”${author}${visual}`;
    })
    .join('\n\n');
};

export const SocialFormat = ({ data }) => {
  if (!data) return <p className="text-sm text-gray-500">No social format available.</p>;

  // Supports rich seed shape AND fallback (.twitter/.instagram/.linkedin).
  const carousel = data.instagram_carousel;
  const tiktok = data.tiktok_concept;
  const facebook = data.facebook_post;
  const quoteCards = data.quote_cards;
  const ctaOptions = data.cta_options;
  const engagement = data.engagement_prompts;
  // Fallback fields
  const twitter = data.twitter;
  const instagram = data.instagram;
  const linkedin = data.linkedin;

  return (
    <div data-testid="social-format">
      {Array.isArray(carousel) && carousel.length > 0 && (
        <CopyableBlock
          label="Instagram Carousel (slides)"
          content={carousel.map((s, i) => `Slide ${i + 1}: ${s}`).join('\n')}
          testId="copy-social-carousel"
        />
      )}
      <CopyableBlock label="TikTok / Reel Concept" content={tiktok} testId="copy-social-tiktok" />
      <CopyableBlock label="Facebook Post" content={facebook} testId="copy-social-facebook" />
      {Array.isArray(quoteCards) && quoteCards.length > 0 && (
        <CopyableBlock label="Quote Cards" content={renderQuoteCards(quoteCards)} testId="copy-social-quotes" />
      )}
      {Array.isArray(ctaOptions) && ctaOptions.length > 0 && (
        <CopyableBlock
          label="CTA Options"
          content={ctaOptions.map((c) => `• ${c}`).join('\n')}
          testId="copy-social-cta"
        />
      )}
      {Array.isArray(engagement) && engagement.length > 0 && (
        <CopyableBlock
          label="Engagement Prompts"
          content={engagement.map((c) => `• ${c}`).join('\n')}
          testId="copy-social-engagement"
        />
      )}
      <CopyableBlock label="Twitter / X" content={twitter} testId="copy-social-twitter" />
      <CopyableBlock label="Instagram Caption" content={instagram} testId="copy-social-ig" />
      <CopyableBlock label="LinkedIn" content={linkedin} testId="copy-social-linkedin" />
    </div>
  );
};

export default SocialFormat;
